import { useBankCountries } from '../fetchHooks/useCountryDetails';
import type { Country, CountryCode } from '../generated-types';

const useBankCountry = (countryCode?: CountryCode): Country | undefined => {
    const { data: bankCountryList } = useBankCountries();

    return bankCountryList?.find((country) => country.countryCode.value === countryCode?.value);
};

export default useBankCountry;
